import { currentBreakpoint } from '../lib/responsive';
import { standardListener } from '../config/vars';
import { debounce } from 'lodash';

export default class BackToTop {

  constructor(el) {

    this.el = el;
 
    this.body = document.body || document.documentElement;

    this.onScrollHandler = debounce(this.scrollHandler.bind(this), 150);

    this.scrollToTop = this.scrollTop.bind(this);

    this.registerEvents();
  }

  registerEvents() {

    window.addEventListener('scroll', this.onScrollHandler, Modernizr.passiveeventlisteners ? {
      passive: true
    } : false);
    this.el.addEventListener(standardListener, this.scrollToTop);
  }

  scrollHandler() {

    if (currentBreakpoint === 's' || currentBreakpoint === 'xs') {

      return;
    }

    return (window.pageYOffset > 200) ? this.el.classList.add('is-active') : this.el.classList.remove('is-active');
  }

  scrollTop() {
    window.scrollTo({
      top: 100,
      left: 100,
      behavior: 'smooth'
    });
  }
}
